// Turns Slidecart's shipping protection ("Forsikret Forsendelse") on by default.
// If the customer switches it off in the cart, it stays off for that cart.
(() => {
  const variantId = Number(window.insuredShippingVariantId);
  if (!variantId || window.__insuredShippingDefault) return;
  window.__insuredShippingDefault = true;

  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
  const storageKey = "insured_shipping_state";
  let busy = false;
  let queued = false;

  const readState = () => {
    try {
      return JSON.parse(sessionStorage.getItem(storageKey)) || {};
    } catch (e) {
      return {};
    }
  };
  const writeState = (state) => {
    try {
      sessionStorage.setItem(storageKey, JSON.stringify(state));
    } catch (e) {}
  };

  async function check() {
    if (busy) {
      queued = true;
      return;
    }
    busy = true;

    try {
      let cart = await originalFetch(`${root}cart.js`).then((r) => r.json());
      const insured = cart.items.some((item) => item.variant_id === variantId);
      const hasProducts = cart.items.some((item) => item.variant_id !== variantId);
      const state = readState();
      if (state.token !== cart.token) Object.assign(state, { token: cart.token, optOut: false, last: null });

      // Protection was on and products are still there, so the customer switched it off.
      if (state.last && state.last.products && state.last.insured && hasProducts && !insured) {
        state.optOut = true;
      }
      if (insured) state.optOut = false;

      if (hasProducts && !insured && !state.optOut) {
        await originalFetch(`${root}cart/add.js`, {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
        });
        cart = await originalFetch(`${root}cart.js`).then((r) => r.json());
        if (typeof window.SLIDECART_SET_CART === "function") window.SLIDECART_SET_CART(cart);
        state.last = { products: true, insured: true };
      } else {
        state.last = { products: hasProducts, insured };
      }

      writeState(state);
    } catch (e) {
      console.error(e);
    } finally {
      busy = false;
      if (queued) {
        queued = false;
        setTimeout(check, 300);
      }
    }
  }

  // Slidecart has no per-language title for shipping protection, so translate it here.
  const titles = { fr: "Expédition assurée" };
  const locale = String((window.Shopify && Shopify.locale) || document.documentElement.lang || "").slice(0, 2);
  function translateTitle() {
    if (!titles[locale] || typeof window.SLIDECART_STATE !== "function") return false;
    const settings = window.SLIDECART_STATE().settings;
    if (!settings) return false;
    settings.shipping_protection_title = titles[locale];
    return true;
  }
  if (titles[locale]) {
    let tries = 0;
    const timer = setInterval(() => {
      if (translateTitle() || ++tries > 40) clearInterval(timer);
    }, 250);
  }

  const isCartChange =(url) => /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(String(url));

  const originalFetch = window.fetch.bind(window);
  window.fetch = function (input, init) {
    const url = typeof input === "string" ? input : input && input.url;
    const request = originalFetch(input, init);
    if (isCartChange(url)) request.then(() => setTimeout(check, 300)).catch(() => {});
    return request;
  };

  const originalOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (isCartChange(url)) this.addEventListener("loadend", () => setTimeout(check, 300));
    return originalOpen.apply(this, arguments);
  };

  check();
})();
